import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import RegistrationTypeServices from "services/RegistrationTypeServices";
import { notifyError, notifySuccess } from "utils/toast";

const useRegistrationTypeSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);

      const RegistrationTypeData = {

        name:data.name,
       
      };

      if (id) {
        const res = await RegistrationTypeServices.updateRegistrationType(id, RegistrationTypeData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await RegistrationTypeServices.addRegistrationType(RegistrationTypeData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getRegistrationTypeData = async () => {
    try {
      const res = await RegistrationTypeServices.getRegistrationTypeById(id);
      if (res) {
        setValue("name",res.name);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("name");
      clearErrors("name");
      return;
    }
      
    if (id) {
      getRegistrationTypeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    trigger,
    register,
    handleSubmit,loading,setLoading,
    onSubmit,
    errors,
    isSubmitting,
  };
};

export default useRegistrationTypeSubmit;
